<template>
    <div>
        <!-- DIALOGS -->
        <SelectionRequiredDialog /> 
		<DeletionDialog :context="'Selected' + context" />
        <ProFormaDialog />

        <BaseListPage
			headline="lang_ERP_SHIPPING"
            :context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
		>
            <template v-slot:filter>
                <v-col>
                    <DropdownFilter 
                        :context="context + 'TypeFilter'"
                        label="lang_ERP_INVOICES_CAPTION_TYPE"
                        :items="typeItems"
                        :alvqa="alvqa + '-list-dropdown-type-filter'"
                    />
                </v-col>
                <v-col cols="2">
                    <DropdownFilter 
                        :context="context + 'StatusFilter'"
                        label="lang_ERP_INVOICES_CAPTION_STATUS"
                        :items="statusItems"
                        :alvqa="alvqa + '-list-dropdown-status-filter'"
                    />
                </v-col>
                <v-col cols="2">
                    <DatePickerFilter 
                        :context="context + 'PeriodFromFilter'"
                        :label="$t('lang_GENERIC_CAPTION_PERIOD_FROM')"
                        :alvqa="alvqa"
                    />
                </v-col>
                <v-col cols="2">
                    <DatePickerFilter 
                        :context="context + 'PeriodToFilter'"
                        :label="$t('lang_GENERIC_CAPTION_PERIOD_TO')"
                        :alvqa="alvqa"
                    />
                </v-col>
            </template>
            <template v-slot:dataTable>
                <BaseDataTableList 
                    :headers="headers"
                    :context="context"
                    readOnlyGhostTdSpan="1"
                    :alvqa="alvqa"
                    :hasServerSideSorting="true"
                    :stickyTopSlot="true"
                >
                    <template v-slot:topSlot> <ShippingTopSlot /> </template> 

                    <template v-slot:headers="{ header }">{{ header }}</template>

                    <template v-slot:body="{ item }">

                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
                        />

                        <!-- <td class="no_ellipsis" :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-number'">
                            {{ item.item.number }}
                        </td> -->
                        
                        <td>
                            <BaseTooltip>
                                <template v-slot:text>{{ item.item.number }}</template>
                                <template v-slot:content>
                                    <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-number'">
                                        {{ item.item.number}}
                                    </span>
                                </template>
                            </BaseTooltip>
                        </td>

                        <td v-if="item.item.date != null" class="no_ellipsis" :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-date'">
                            {{ $d(new Date(item.item.date), 'alvDateFormat', $i18n.locale) }}</td>

                        <td class="no_ellipsis" :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-type'">
                            <BaseTooltip>
                            <template v-slot:text>{{ $t(getLangOfShippingType(item.item.type)) }}</template>
                                <template v-slot:content>
                                    <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-type'">
                                        {{ $t(getLangOfShippingType(item.item.type, "abbr")) }}
                                    </span>
                                </template>
                            </BaseTooltip>
                        </td>

                        <td class="ellipsis">
                            <BaseTooltip>
                                <template v-slot:text>{{ item.item.recipientName + ' (' + item.item.recipient.alvId + ')' }}</template>
                                <template v-slot:content>
                                    <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-recipient'">
                                        {{ item.item.recipientName}}
                                    </span>
                                </template>
                            </BaseTooltip>
                        </td>

                        <td class="ellipsis">
                            <BaseTooltip>
                                <template v-slot:text>{{ item.item.senderName + ' (' + item.item.sender.alvId + ')'}}</template>
                                <template v-slot:content>
                                    <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-sender'">
                                        {{ item.item.senderName}}
                                    </span>
                                </template>
                            </BaseTooltip>
                        </td>

                        <td v-if="item.item.status != null" class="no_ellipsis" :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-shipping-status'">
                            {{ $t(getLangOfStatus(item.item.status)) }}
                        </td>

                        <!-- Linked Documents -->
                        <td>
                            <!-- Linked Shipping -->
                            <BaseTooltip v-if="item.item.linkedShipping !== null">
                                <template v-slot:text>
                                    {{ $t(getLangOfShippingType(item.item.linkedShipping.type, 'text')) }} 
                                    {{ item.item.linkedShipping.number }} <br />
                                    <div style="text-align:center">{{ item.item.linkedShipping.alvId }}</div>
                                </template>
                                <template v-slot:content>
                                    <BaseButton v-if="item.item.linkedInvoice !== null"
                                        :label="getLangOfShippingType(item.item.linkedShipping.type, 'abbr')"
                                        @click.stop="jumpToShipping(item.item.linkedShipping.alvId)"
                                        />
                                    <BaseButton v-else
                                        :label="getLangOfShippingType(item.item.linkedShipping.type, 'text')"
                                        @click.stop="jumpToShipping(item.item.linkedShipping.alvId)"
                                        />
                                </template>
                            </BaseTooltip>

                            <!-- Linked Invoice -->
                            <BaseTooltip v-if="item.item.linkedInvoice !== null">
                                <template v-slot:text>
                                    {{ $t(getLangOfInvoiceType(item.item.linkedInvoice.type, 'text')) }} 
                                    {{ item.item.linkedInvoice.number }} <br />
                                    <div style="text-align:center">{{ item.item.linkedInvoice.alvId }}</div>
                                </template>
                                <template v-slot:content>
                                    <span v-if="item.item.linkedShipping !== null" class="pl-2">
                                        <BaseButton 
                                            :label="getLangOfInvoiceType(item.item.linkedInvoice.type, 'abbr')"
                                            @click.stop="jumpToInvoice(item.item.linkedInvoice.alvId)"
                                            />
                                    </span>
                                    <span v-else>
                                        <BaseButton 
                                            :label="getLangOfInvoiceType(item.item.linkedInvoice.type, 'text')"
                                            @click.stop="jumpToInvoice(item.item.linkedInvoice.alvId)"
                                            />
                                    </span>
                                </template>
                            </BaseTooltip>
                        </td>

                    </template>

                    <template v-slot:expandSlot="{ id }"><ShippingReadOnly :itemId='id' /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import BaseButton from '@/components/_buttons/BaseButton'
    import BaseDataTableList from '@/components/_base/BaseDataTableList'
    import BaseIcon from '@/components/_buttons/BaseIcon'
    import BaseListPage from '@/components/_base/BaseListPage'
    import BaseTooltip from '@/components/_base/BaseTooltip'
    import ExpandIcon from '@/components/_buttons/ExpandIcon'
    import DeletionDialog from '@/components/_dialogs/DeletionDialog'
    import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
    import ProFormaDialog from './_dialogs/ProFormaDialog'
    import ShippingReadOnly from './_readonly/ShippingReadOnly'
    import ShippingTopSlot from './ShippingTopSlot'
    import DatePickerFilter from '@/components/_filters/DatePickerFilter'
    import DropdownFilter from '@/components/_filters/DropdownFilter'

    import {    DropdownErpShippingStatus, 
                DropdownErpShippingType,
                DropdownErpInvoicesType
                } from '@/assets/dropdowns/alvDropdowns.js'

        export default {
            name: 'ShippingList',						
            components: {
                BaseListPage,
                BaseDataTableList,
                BaseTooltip,
                BaseIcon,
                DeletionDialog,
                ExpandIcon,
                BaseButton,
                SelectionRequiredDialog,
                ProFormaDialog,
                ShippingReadOnly,
                ShippingTopSlot,
                DatePickerFilter,
                DropdownFilter
            },
            data() {
                return {
                    context: "Shipping",
                    alvqa: "erp-shipping"
                }
            },
            methods: {
                getLangOfStatus(selection) {
                    return DropdownErpShippingStatus.find(obj => {
                        return obj.value == selection
                    }).text
                },
                getLangOfShippingType(selection, type = "text") {
                    return DropdownErpShippingType.find(obj => {
                        return obj.value == selection
                    })[type]
                },
                getLangOfInvoiceType(selection, type = "text") {
                    return DropdownErpInvoicesType.find(obj => {
                        return obj.value == selection
                    })[type]
                },
                jumpToInvoice(alvId) {
                    this.$store.commit('setInvoicesSearch', alvId)
                    this.$store.commit('setExpandedInvoices', [])
                    this.$store.commit('setExpandedInvoices', alvId)
                    this.$router.push( { name: 'Invoices' })
                    this.$store.dispatch('fetchInvoicesDetails', alvId)
                },
                jumpToShipping(alvId) {
                    this.$store.commit('setCurrentPage', 1)
                    this.$store.commit('setShippingSearch', alvId)
                    this.$store.commit('setExpandedShipping', [])
                    this.$store.commit('setExpandedShipping', alvId)
                    this.$store.dispatch('fetchShipping')
                }
            },
            computed: {
                ...mapGetters(['getShippingSearch']),
                
                headers() {
                    return [
                        { // column 01: Select
                            text: '', 
                            value: 'data-table-select', 
                            width: "60px",
                            sortable: false,
                            class: 'text-no-wrap'
                        },
                        { // column 02: Read-only view
                            text: '', 
                            value: 'data-table-expand',
                            align: 'center', 
                            width: "48px",
                            sortable: false,
                            class: 'text-no-wrap'
                        },
                        { // column 03: shipping Number
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_NUMBER_ABBREVIATION'), 
                            value: 'number', 
                            align: 'left', 
                            width: '150px',
                            sortable: true,
                            class: 'text-no-wrap',
                        },
                        { // column 04: shipping Date
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_DATE_ABBREVIATION'), 
                            value: 'date', 
                            align: 'left', 
                            sortable: true,
                            width: "90px",
                            class: 'text-no-wrap'
                        },
                        { // column 05: shipping Type
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_TYPE'), 
                            value: 'type', 
                            align: 'left', 
                            sortable: false,
                            width: "50px",
                            class: 'text-no-wrap'
                        },
                        { // column 06: shipping Recipient
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_RECIPIENT_ABBREVIATION'), 
                            value: 'recipientName', 
                            align: 'left', 
                            sortable: true,
                            class: 'text-no-wrap'
                        },
                        { // column 07: shipping Sender
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_SENDER_ABBREVIATION'), 
                            value: 'senderName', 
                            align: 'left', 
                            sortable: true,
                            class: 'text-no-wrap'
                        },
                        { // column 08: shipping Status
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_STATUS'), 
                            value: 'status', 
                            align: 'left', 
                            sortable: false,
                            width: "100px",
                            class: 'text-no-wrap'
                        },
                        { // column 09: shipping Linked Documents, can be other shipping docs and/or invoices
                            text: this.$t('lang_ERP_SHIPPING_CAPTION_LINKED_DOC'), 
                            value: 'linkedDocuments', 
                            align: 'left', 
                            sortable: false,
                            width: "200px",
                            class: 'text-no-wrap'
                        },
                        {
                            text: '', 
                            value: 'editForm',
                            align: 'right',
                            sortable: false,
                            width: "70px",
                            class: 'text-no-wrap'
                        },
                    ]
                },
                typeItems() { return DropdownErpShippingType },
                statusItems() { return DropdownErpShippingStatus },
            }
        }
</script>